import React from "react";
import { engagements, contactInfo } from "../data/mock";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";
import { Reveal, ChapterTag } from "../lib/motion";

export const ServicesSection = () => {
  return (
    <section id="work-together" data-testid="engagements-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <ChapterTag num="07" label="Ways to work together" />
          <h2 className="mt-6 font-display font-semibold text-stone-900 tracking-tight text-3xl sm:text-4xl lg:text-5xl max-w-3xl leading-[1.1]">
            {engagements.heading}
          </h2>
          <p className="mt-4 text-stone-500 font-display  text-base md:text-lg">{engagements.intro}</p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {engagements.items.map((item, i) => {
            const Icon = item.icon;
            return (
              <Reveal
                key={i}
                delay={i * 0.1}
                className="group relative rounded-3xl border border-stone-200 bg-[#FAF7F2] p-8 flex flex-col hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgba(3,46,45,0.08)] transition-all duration-400"
                data-testid={`engagement-card-${i}`}
              >
                <div className="absolute top-0 left-8 right-8 h-[3px] rounded-b" style={{ background: item.accent }} />
                <div className="w-12 h-12 rounded-2xl flex items-center justify-center mb-6" style={{ background: `${item.accent}1a` }}>
                  <Icon className="w-5 h-5" style={{ color: item.accent }} />
                </div>
                <h3 className="font-display font-semibold text-xl sm:text-2xl text-stone-900 leading-tight">{item.title}</h3>
                <p className="mt-2 font-display  text-base" style={{ color: item.accent }}>{item.subtitle}</p>
                <p className="mt-4 text-sm text-stone-600 leading-relaxed">{item.copy}</p>

                <div className="mt-6">
                  <p className="text-[11px] font-semibold text-stone-400 uppercase tracking-[0.18em] mb-3">{item.usesLabel}</p>
                  <ul className="space-y-1.5">
                    {item.uses.map((use, j) => (
                      <li key={j} className="text-sm text-stone-600 flex items-start gap-2">
                        <span className="mt-[9px] w-1 h-1 rounded-full flex-shrink-0" style={{ background: item.accent }} />
                        {use}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="mt-8 pt-2 mt-auto">
                  <Button
                    onClick={() => window.open(contactInfo.bookingUrl, "_blank", "noopener,noreferrer")}
                    data-testid={`engagement-cta-${i}`}
                    variant="outline"
                    className="w-full rounded-full h-11 border-stone-300 text-stone-800 hover:text-white text-sm font-medium transition-all duration-300 group-hover:border-transparent"
                    style={{ "--hover-bg": item.accent }}
                    onMouseEnter={(e) => { e.currentTarget.style.background = item.accent; e.currentTarget.style.borderColor = item.accent; }}
                    onMouseLeave={(e) => { e.currentTarget.style.background = ""; e.currentTarget.style.borderColor = ""; }}
                  >
                    {item.cta}
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-10 text-center text-sm text-stone-500  max-w-2xl mx-auto" data-testid="engagements-note">
            {engagements.note}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
